<template>
  <v-card>
    <v-card-text :style="{ borderTop: color ? `7px solid ${color}` : '' }">
      <p class="mb-0">
        {{ title }}
      </p>
    </v-card-text>
    <v-simple-table class="stats-card-table">
      <template #default>
        <slot />
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: false,
      default: null
    }
  }
}
</script>

<style>
  .stats-card-table td {
    border-radius: 0 !important;
  }
</style>